
import { AuthTemplate } from '@/pages/unauthenticated/auth/components';

import { Logout } from './logout';

export default function LogoutPage() {
  return (
    <AuthTemplate
      heading="Logging out"
      subheading="You will be redirected shortly..."
    >
      <Logout />
    </AuthTemplate>
  );
}
